<template>
  <div class="background">
    <div class="background__gradient background__gradient--blue"></div>
    <div class="background__gradient background__gradient--green"></div>
  </div>
</template>

<script setup>
import { onMounted, inject } from "vue";

const gsap = inject("$gsap");

onMounted(() => {
  // TODO: Animate the gradients.
});
</script>

<style lang="scss">
.background {
  position: fixed;
  height: 100%;
  width: 100%;
  background: var(--background);
  overflow: hidden;
  z-index: -1;

  &__gradient {
    width: 50rem;
    height: 50rem;
    position: absolute;
    opacity: var(--backgroundGradientOpacity);
    filter: blur(12rem);

    &--green {
      top: 0;
      right: 0;
      background: radial-gradient(
        circle,
        rgba(0, 214, 191, 1) 0%,
        rgba(0, 214, 191, 0) 70%
      );
      transform: translateX(50%) translateY(-50%);
    }

    &--blue {
      top: 0;
      right: 0;
      background: radial-gradient(
        circle,
        rgba(0, 114, 206, 1) 0%,
        rgba(0, 114, 206, 0) 70%
      );
      transform: translateX(60%) translateY(30%);
      transform-origin: 0% 0%;
    }

    &--pink {
      bottom: 0;
      left: 0;
      background: radial-gradient(
        circle,
        rgba(229, 64, 255, 1) 0%,
        rgba(229, 64, 255, 0) 70%
      );
      transform: translateX(-50%) translateY(50%);
    }
  }
}
</style>
